import axios from '@shared/axios-shared';
import { mergeUserParams } from '@shared/services/schools.js';

const getTotalStaffs = (page = 1) => {
	let config = mergeUserParams({ page });
	return axios.get(`/api/v1/company/staff`, config);
};

const getTotalRooms = (page = 1) => {
	let config = mergeUserParams({ page });
	return axios.get(`/api/v1/company/rooms`, config);
};

const allStudents = (page = 1) => {
	let config = mergeUserParams({ page });
	return axios.get(`/api/v1/company/all-students?`, config);
};

const getTotalSubAdmin = (page = 1) => {
	let config = mergeUserParams({ page });
	return axios.get(`/api/v1/company/subadmins`, config);
};

export { getTotalStaffs, getTotalRooms, allStudents, getTotalSubAdmin };
